<div class="rating" [class.padded]="padded">
  <div class="star-rating-container star-rating-animation">
    <span>
      {{ labelKey | locLabel }}
    </span>
    <div *ngFor="let class of starClasses; index as i" class="star" [ngClass]="class" (click)="value = i + 1">
      <mat-icon>star</mat-icon>
    </div>
  </div>
</div>

